<template>
    <div class="time-picker">      
      <select v-model="selectedHour" @change="updateTime">
        <option v-for="hour in hours" :key="hour" :value="hour" >
          {{ formatNumber(hour)  }}
        </option>
      </select>
      :
      <select v-model="selectedMinute" @change="updateTime">
        <option v-for="minute in minutes" :key="minute" :value="minute" >
          {{ formatNumber(minute) }} 
        </option>
      </select> 
    </div>
  </template>
  
  <script>
  export default {
    props: {
      value: String // Expected format: "HH:mm"
    },
    data() {
      return {
        selectedHour: "00",
        selectedMinute: "00",
        hours: Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0')), // 00-23
        minutes: Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0')) // 00-59
      };
    },
    watch: {
      value: {
        immediate: true,
        handler(newValue) {
          if (newValue) {
            const [hour, minute] = newValue.split(":");
            this.selectedHour = this.formatNumber(hour);
            this.selectedMinute = this.formatNumber(minute);
          }
        }
      }
    },
    methods: {
      updateTime() {
        const newTime = `${this.formatNumber(this.selectedHour)}:${this.formatNumber(this.selectedMinute)}`;
        this.$emit("input", newTime); // Update v-model binding
      },
      formatNumber(num) {
        return String(num).padStart(2, "0"); // Ensures two-digit format (e.g., 05, 09)
      }
    }
  };
  </script>
  
  <style scoped>
  .time-picker {
    display: flex;
    gap: 3px;
    align-items: center;
    
  }
  select {
    padding: 3px;
    padding-left:8px;
    padding-right:8px;
    font-size: 14px;
    border:1px solid #ccc;
  }
  </style>
  